import React, { useState } from 'react';
import { FlatList, Image, TouchableOpacity } from "react-native"
import { Icons } from '../../Components';
import ImageUploader from '../../Components/ImageUploader';
import Colors from '../../constants/colors';
import { ProfileApi } from '../api';
import { button_styles } from '../../constants/styles';
import type { MyPlayerProps } from '../../types';
import { Button, Text, View } from '../../Components/Themed';

type ProfilePicManagerProps = {
    player:MyPlayerProps, 
    width:number,
    walkthrough?:boolean,
    onClose:() => void,
    onNext:() => void,
    onPlayerUpdate:(player:MyPlayerProps) => void
}

const sections = ['header','pic'];
const ProfilePicManager = ({ player, width, onPlayerUpdate, walkthrough, onNext, onClose }:ProfilePicManagerProps) => {
    const [ loading, setLoading ] = useState(false);

    const handleUpdatePic = async(profile_pic:string) => {
        const new_player = await ProfileApi.updatePlayerPic(profile_pic)
        setLoading(false);
        onPlayerUpdate(new_player)
    }

    const MAX_WIDTH = 500
    const size = width > MAX_WIDTH ? MAX_WIDTH : width

    const renderSections = (data:{ item:string, index:number }) => {
        switch(data.item){
            case 'header':
                if(!walkthrough){ return <></> }
                return (
                    <View style={{ padding:20 }}>
                        <Text size={26} theme='h1'>Update Your Picture</Text>
                        <Text style={{ marginTop:15 }} size={14} theme='h2'>Your profile picture is how users will see you in leaderboards and activity feeds.</Text>
                    </View>
                )
            case 'pic':
                return (
                    <View>
                        <View style={{ margin:5 }}>
                            <ImageUploader
                                public_id={`${player.player_id}_${Math.random()}`}
                                onStartUpload={() => setLoading(true)}
                                onCancelUpload={() => setLoading(false)}
                                onFinishUpload={(obj) => {
                                    console.log(obj)
                                    handleUpdatePic(obj.secure_url)
                                }}
                            >
                                <Button
                                    title={player.profile_pic ? 'CHANGE PICTURE' : 'ADD PICTURE'}
                                    disabled
                                    loading={loading}
                                    type='action'
                                    onPress={() => console.log('NA')}
                                />
                            </ImageUploader>
                        </View>
                        <Image
                            source={{ uri: player.profile_pic ? player.profile_pic :'https://res.cloudinary.com/hoabts6mc/image/upload/v1714408535/sports_avatar_wdzsxc.webp' }}
                            style={{ height:size, width:size, borderRadius:4 }}
                            resizeMode='cover'
                        />
                    </View>
                )
            default: return <></>
        }
    }

    return (
        <View style={{ flex:1 }}>
            <View style={{ flex:1 }}>
                <FlatList
                    data={sections}
                    key={'pic_sections'}
                    keyExtractor={item => item}
                    renderItem={renderSections}
                />
            </View>
            {walkthrough ?
            <View nativeID='action_row' style={{ flexDirection:'row', justifyContent:'space-between', padding:10 }}>
                <Button
                    title='EXIT SETUP'
                    type='text'
                    onPress={() => onClose()}
                />
                <TouchableOpacity 
                    style={loading?button_styles.wizard_invalid:button_styles.wizard_valid}
                    onPress={() => onNext()}
                    disabled={loading}
                    >
                    <Icons.ChevronIcon size={20} direction='right' color={Colors.brand.midnight}/>
                </TouchableOpacity>
            </View>
            :
            <View nativeID='action_row' style={{ flexDirection:'row', justifyContent:'space-between', padding:10 }}>
                <Button
                    style={{ flex:1 }}
                    title='BACK'
                    type='close'
                    onPress={() => onClose()}
                />
            </View>
            }
        </View>
    )
}

export default ProfilePicManager